import { PermissionStatus } from '../models/enums'

const getMicrophonePermission = async (): Promise<PermissionStatus> => {
  try {
    return navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(
        (stream) => {
          return stream ? PermissionStatus.allowed : PermissionStatus.refused
        },
        (reason) => {
          console.log(
            'Retorik Framework > microphone permission refused : ',
            reason
          )
          return PermissionStatus.refused
        }
      )
      .catch((error) => {
        console.log(
          'Retorik Framework > microphone permission refused : ',
          error
        )
        return PermissionStatus.error
      })
  } catch (error) {
    console.log('Retorik Framework > microphone permission refused : ', error)
    return PermissionStatus.error
  }
}

export default getMicrophonePermission
